import {Injectable} from '@angular/core';
import {DisplayPreferences} from '../models/display-preferences.model';

@Injectable({
    providedIn: 'root'
})
export class DisplayPreferencesService {
    title = 'DisplayPreferencesService';

    displayPreferences: DisplayPreferences = {
        showAllAnnotationFeatures: false,
        showAllGeometryFeatures: false,
        showEnlargementFeatures: false,
        showClippingFeatures: false,
        showPrintArea: true
    };

    viewMode: string;
    viewModeResolution: string;

    displayPreferencesChanged(displayPreferences: DisplayPreferences) {
        this.displayPreferences = displayPreferences;
    }
}
